import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    slots: {
        th: 'px-3',
        td: 'text-default p-3'
    },
} satisfies TVConfig<typeof ui>['table'];
